import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

/**
 * SEOHelmet Component
 * 
 * @param {string} title - Page title
 * @param {string} description - Page description
 * @param {string} image - OG image URL
 * @param {string} type - Page type (website, article, etc.)
 * @param {boolean} noIndex - Whether to add a noindex tag
 */
const SEOHelmet = ({ 
  title, 
  description, 
  image = 'https://tekhdem.com/web-app-manifest-512x512.png', 
  type = 'website',
  noIndex = false
}) => {
  const location = useLocation();
  const baseUrl = 'https://tekhdem.com';
  const canonicalUrl = `${baseUrl}${location.pathname}${location.search}`;

  const fullTitle = title ? `${title} | Tekhdem` : 'Tekhdem | Recrutement en Algérie : Offres d\'Emploi';
  const fullDescription = description || 'Tekhdem : Plateforme de recrutement en Algérie. Trouvez votre emploi idéal ou recrutez les meilleurs talents algériens.';

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Robots Tag */}
      {noIndex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEOHelmet;
